const LINKUSER_TOKEN_KEY = 'linkToken'

export const setSessionToken = (token: string) => sessionStorage.setItem(LINKUSER_TOKEN_KEY, token)
export const getSessionToken = () => sessionStorage.getItem(LINKUSER_TOKEN_KEY)
export const removeSessionToken = () => sessionStorage.removeItem(LINKUSER_TOKEN_KEY)
